import { apiSlice } from "app/api/apiSlice";

export const MasterDataApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getmasterState: builder.query({
      query: (searchKey) => `/api/v1/master/states?q=${searchKey}`,
    }),
    getmasterDistrict: builder.query({
      query: () => `/api/v1/master/districts`,
    }),
    getDistrictList: builder.query({
      query: ({ statecode, searchKey }) =>
        `/api/v1/master/districts?state_code=${statecode}&q=${searchKey}`,
    }),
    getSubDistrictList: builder.query({
      query: (statecode) =>
        `/api/v1/master/sub_districts?state_code=${statecode.statecode}&district_code=${statecode.districtcode}&q=${statecode.searchKey}`,
    }),
    getBlockList: builder.query({
      query: (statecode) =>
        `/api/v1/master/blocks?state_code=${statecode.statecode}&district_code=${statecode.districtcode}&q=${statecode.searchKey}`,
    }),
    getGPList: builder.query({
      query: (statecode) =>
        `/api/v1/master/GP?state_code=${statecode.statecode}&district_code=${statecode.districtcode}&q=${statecode.searchKey}`,
    }),
    getVillagesList: builder.query({
      query: (statecode) =>
        `/api/v1/master/villages?state_code=${statecode.statecode}&district_code=${statecode.districtcode}&q=${statecode.searchKey}`,
    }),

    getmasterDropdown: builder.query({
      query: () => `/api/v1/master/dropdowns`,
    }),
    getmasterRoles: builder.query({
      query: () => `/api/v1/auth/roles`,
    }),
    getInstitutes: builder.query({
      query: () => `/api/v1/master/bank_branches?only_bank_names=true`,
    }),
  }),
});

export const {
  useGetmasterStateQuery,
  useGetmasterDistrictQuery,
  useGetDistrictListQuery,
  useGetSubDistrictListQuery,
  useGetBlockListQuery,
  useGetGPListQuery,
  useGetVillagesListQuery,
  useGetmasterDropdownQuery,
  useGetmasterRolesQuery,
  useGetInstitutesQuery,
} = MasterDataApiSlice;
